import { ExtractPropTypes, PropType } from 'vue'

export type ControlsPosition = 'right' | ''

export const inputNumberProps = {
  modelValue: {
    type: Number,
    default: 0
  },
  min: {
    type: Number,
    default: -Infinity
  },
  max: {
    type: Number,
    default: Infinity
  },
  step: {
    type: Number,
    default: 1
  },
  stepStrictly: Boolean,
  precision: {
    type: Number,
    validator: (val: number) => val >= 0 && val === parseInt(val.toString(), 10)
  },
  size: {
    type: String as PropType<'large' | 'small' | ''>,
    default: ''
  },
  disabled: Boolean,
  controls: {
    type: Boolean,
    default: true
  },
  controlsPosition: {
    type: String as PropType<ControlsPosition>,
    default: ''
  },
  name: String,
  placeholder: String,
  readonly: Boolean
} as const

export type InputNumberProps = Partial<
  ExtractPropTypes<typeof inputNumberProps>
>

export const inputNumberEmits = {
  'update:modelValue': (value: number | undefined) => true,
  change: (value: number | undefined) => true,
  blur: (e: FocusEvent) => e instanceof FocusEvent,
  focus: (e: FocusEvent) => e instanceof FocusEvent
}

export type InputNumberEmits = typeof inputNumberEmits
